import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ADMIN_HEADER from "../Admin_Header";
import axios from "axios";

const ADMIN_SCHEDULE_VIEW = () => {
  const { matchCode } = useParams(); // URL에서 matchCode 파라미터 받기
  const [presentationData, setPresentationData] = useState([]);
  const [selectedPresentation, setSelectPresentation] = useState([]);
  const [, setPresentation] = useState([]);
  const [, setAllPresentation] = useState([]);
  
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
	const titleElement = document.getElementsByTagName("title")[0];
	titleElement.innerHTML = `아소비 관리자 페이지`;
	
    const fetchPresentationData = async () => {
      try {
        // matchCode로 Presentation 데이터 가져오기
        const response = await axios.get(`/presenlist/${matchCode}`);
        const sortedData = response.data.sort((a, b) => {
          // 한글 알파벳 순으로 정렬 (가나다 순)
          return a.jisaName.localeCompare(b.jisaName);
        });
        setPresentationData(sortedData);
      } catch (error) {
        console.error("Error fetching Presentation data:", error);
      }
    };

    fetchPresentationData();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, [matchCode]);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  // 체크박스 선택 처리
  const handleCheckboxChange = (presentationIdx, isChecked) => {
    if (isChecked) {
      setSelectPresentation((prevSelected) => [
        ...prevSelected,
        presentationIdx,
      ]);
    } else {
      setSelectPresentation((prevSelected) =>
        prevSelected.filter((idx) => idx !== presentationIdx)
      );
    }
  };

  // 선택 삭제 처리
  const handleDeleteSelected = async () => {
    try {
      if (selectedPresentation.length === 0) {
        alert("삭제할 항목을 선택해주세요.");
        return;
      }

      const confirmation = window.confirm(`선택된 항목을 삭제 하시겠습니까?`);
      if (!confirmation) {
        return;
      }

      const response = await axios.post("/deletepresentation", {
        ids: selectedPresentation,
      });

      if (response.data.success) {
        setPresentation((prevPresentation) =>
          prevPresentation.filter(
            (presentation) => !selectedPresentation.includes(presentation.idx)
          )
        );
        setAllPresentation((prevAllApply) =>
          prevAllApply.filter(
            (presentation) => !selectedPresentation.includes(presentation.idx)
          )
        );
        setSelectPresentation([]); // 선택된 항목 초기화
        alert("선택한 항목이 삭제되었습니다.");
        window.location.reload();
      } else {
        alert("삭제 실패");
      }
    } catch (error) {
      console.error("삭제 중 오류 발생:", error);
      alert("삭제 중 오류가 발생했습니다.");
    }
  };

  // 입력 필드 값 수정
  const handleInputChange = (presentationIdx, field, value) => {
    setPresentationData((prevData) =>
      prevData.map((presentation) =>
        presentation.idx === presentationIdx
          ? { ...presentation, [field]: value }
          : presentation
      )
    );
  };

  // 수정 버튼 클릭 시 처리
  const handleUpdate = async (presentationIdx) => {
    const updatedData = presentationData.find(
      (presentation) => presentation.idx === presentationIdx
    );

    try {
      // 서버에 수정된 데이터 보내기
      await axios.put(`/presenlist/${presentationIdx}`, updatedData);
      alert("수정이 완료되었습니다.");
      window.location.reload();
    } catch (error) {
      console.error("수정 실패:", error);
      alert("수정에 실패했습니다.");
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="main_compo">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 창업 일정 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">데이터 관리</h3>
                <ul className="snb_list">
				{permissions.ent && (
				  <li>
				    <a href="/admin/form/ent">입회신청 관리</a>
				  </li>
				)}
				{permissions.fr && (
				  <li>
				    <a href="/admin/form/fr">창업신청 관리</a>
				  </li>
				)}
				{permissions.franchise && (
				  <li>
				    <a href="/admin/form/franchise">가맹점 관리</a>
				  </li>
				)}
				{permissions.schedule && (
				  <li className="cur">
				    <a href="/admin/form/schedule">창업일정 관리</a>
				  </li>
				)}
				{permissions.jisa && (
				  <li>
				    <a href="/admin/form/jisa">지사장 지원 관리</a>
				  </li>
				)}
				{permissions.q && (
				  <li>
				    <a href="/admin/form/q">앱 문의 관리</a>
				  </li>
				)}
				{permissions.etc_q && (
				  <li>
				    <a href="/admin/form/etc_q">기타문의 관리</a>
				  </li>
				)}
                  {(localStorage.getItem("adminId") === "jiwoo" ||
                    localStorage.getItem("adminId") === "nixona" ||
                    localStorage.getItem("adminId") === "wjdrnr90" ||
                    localStorage.getItem("adminId") === "hyoseon.jang") && (
                    <li>
                      <a href="/admin/form/point">적립금 정산 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td className="right_m">
              <div className="sec-cont">
                <div className="view-btn">
                  <span
                    className="btn custom_s"
                    style={{ backgroundColor: "red" }}
                  >
                    <button onClick={handleDeleteSelected}>선택 삭제</button>
                  </span>
                  <span className="btn custom_s">
                    <button>
                      <Link to="/admin/form/schedule" style={{ color: "#fff" }}>
                        창업 일정 목록
                      </Link>
                    </button>
                  </span>
                </div>
                <div className="tb_01">
                  <table style={{ marginTop: "10px" }}>
                    <thead>
                      <tr>
                        <th>선택</th>
                        <th>번호</th>
                        <th>지사</th>
                        <th>지역</th>
                        <th>상세지역</th>
                        <th>연락처</th>
                        <th>장소</th>
                        <th>오픈톡</th>
                        <th>X좌표</th>
                        <th>Y좌표</th>
                        <th>수정</th>
                      </tr>
                    </thead>
                    <tbody className="sechduleview">
                      {/* matchCode에 맞는 Presentation 데이터 출력 */}
                      {presentationData.length === 0 ? (
                        <p>데이터가 없습니다.</p>
                      ) : (
                        presentationData.map((presentation, index) => (
                          <tr key={presentation.idx}>
                            <td>
                              <input
                                type="checkbox"
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    presentation.idx,
                                    e.target.checked
                                  )
                                }
                              />
                            </td>
                            <td>{index + 1}</td>
                            <td>{presentation.jisaName}</td>
                            <td>{presentation.sido}</td>
                            <td>{presentation.gungu}</td>
                            <td>
                              <input
                                className="updatetext"
                                type="text"
                                value={presentation.tel}
                                onChange={(e) =>
                                  handleInputChange(
                                    presentation.idx,
                                    "tel",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="updatetext"
                                type="text"
                                value={presentation.place}
                                onChange={(e) =>
                                  handleInputChange(
                                    presentation.idx,
                                    "place",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="updatetext"
                                type="text"
                                value={presentation.kakao}
                                onChange={(e) =>
                                  handleInputChange(
                                    presentation.idx,
                                    "kakao",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="updatetext"
                                type="text"
                                value={presentation.urlX}
                                onChange={(e) =>
                                  handleInputChange(
                                    presentation.idx,
                                    "urlX",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="updatetext"
                                type="text"
                                value={presentation.urlY}
                                onChange={(e) =>
                                  handleInputChange(
                                    presentation.idx,
                                    "urlY",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <button
                                onClick={() => handleUpdate(presentation.idx)}
                                className="svbutton"
                              >
                                수정
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="view-btn">
                <span
                  className="btn custom_s"
                  style={{ backgroundColor: "red" }}
                >
                  <button onClick={handleDeleteSelected}>선택 삭제</button>
                </span>
                <span className="btn custom_s">
                  <button>
                    <Link to="/admin/form/schedule" style={{ color: "#fff" }}>
                      창업 일정 목록
                    </Link>
                  </button>
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default ADMIN_SCHEDULE_VIEW;
